.layout {
  container-type: inline-size;
}
.grid {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 0.875rem 0.75rem;
  > .item {
    grid-column: span 6;
  }
  &:has(> :nth-child(7)):not(:has(> :nth-child(8))) > .item:last-child {
    grid-column: 1 / -1;
    justify-self: center;
  }
}
@container (min-width: 32rem) {
  .grid > .item {
    grid-column: span 4;
  }

  .grid:has(> :nth-child(7)) {
    grid-template-columns: repeat(24, minmax(0, 1fr));
  }
  .grid:has(> :nth-child(7)) > .item {
    grid-column: span 6;
  }
  .grid:has(> :nth-child(7)):not(:has(> :nth-child(8))) {
    > .item:nth-child(5) {
      grid-column: 4 / span 6;
    }
    > .item:nth-child(6) {
      grid-column: 10 / span 6;
    }
    > .item:nth-child(7) {
      grid-column: 16 / span 6;
      justify-self: stretch;
    }
  }
}

.item {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
}

.ring {
  display: inline-flex;
  flex-shrink: 0;
  color: var(--color-foreground);

  :global(.calmlens-progress-circle-content) svg {
    width: 0.9375rem;
    height: 0.9375rem;
  }

  :global(.calmlens-progress-circle-value) {
    transition: stroke-dashoffset 800ms var(--ease-strong-out);
  }
}

.copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.score {
  color: var(--color-muted);
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 0.6875rem;
}

.verdict {
  color: var(--color-success);
  font-size: 0.6875rem;
  font-weight: 600;
}

/* Rings fill one after another when scores arrive together. */
@for $i from 2 through 8 {
  .grid > .item:nth-child(#{$i}) :global(.calmlens-progress-circle-value) {
    transition-delay: ($i - 1) * 50ms;
  }
}
